import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";

import PageLoader from "../../helpers/PageLoader";
import NoDataAvailable from "../../helpers/NoDataAvailable";
import ClientListingTable from "../../components/SalesComponent/ClientListingTable";
import ClientListingFilter from "../../components/SalesComponent/ClientListingFilter";
import { FaFilter } from "react-icons/fa";


const defaultFilters = {
  search: "",

  status: [],
  clientType: [],
  category: [],

  state: [],
  country: [],

  handleBy: [],
  createdBy: [],

  onboardingFrom: "",
  onboardingTo: "",

  createdFrom: "",
  createdTo: "",
};

export default function ClientListing() {
  const token = localStorage.getItem("ata");

  const [loading, setLoading] = useState(false);

  const [clients, setClients] = useState([]);

  const [showFilter, setShowFilter] = useState(false);

  const [filters, setFilters] = useState(defaultFilters);

  const [appliedFilters, setAppliedFilters] = useState(defaultFilters);

  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 1,
  });
  const [filterOptions, setFilterOptions] = useState({
    categories: [],
    states: [],
    countries: [],
    users: [],
  });
  useEffect(() => {
    if (token) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
  }, [token]);

  const buildQuery = useCallback(() => {
    const params = new URLSearchParams();

    params.append("page", pagination.page);
    params.append("limit", pagination.limit);

    if (appliedFilters.search) params.append("search", appliedFilters.search);

    if (appliedFilters.status.length)
      params.append("status", appliedFilters.status.join(","));

    if (appliedFilters.clientType.length)
      params.append("clientType", appliedFilters.clientType.join(","));

    if (appliedFilters.category.length)
      params.append("category", appliedFilters.category.join(","));

    if (appliedFilters.state.length)
      params.append("state", appliedFilters.state.join(","));

    if (appliedFilters.country.length)
      params.append("country", appliedFilters.country.join(","));

    if (appliedFilters.handleBy.length)
      params.append("handleBy", appliedFilters.handleBy.join(","));

    if (appliedFilters.createdBy.length)
      params.append("createdBy", appliedFilters.createdBy.join(","));

    if (appliedFilters.onboardingFrom)
      params.append("onboardingFrom", appliedFilters.onboardingFrom);

    if (appliedFilters.onboardingTo)
      params.append("onboardingTo", appliedFilters.onboardingTo);

    if (appliedFilters.createdFrom)
      params.append("createdFrom", appliedFilters.createdFrom);

    if (appliedFilters.createdTo)
      params.append("createdTo", appliedFilters.createdTo);

    return params.toString();
  }, [pagination.page, pagination.limit, appliedFilters]);

  const fetchClients = useCallback(async () => {
    try {
      setLoading(true);

      const query = buildQuery();

      const response = await api.get(
        `${SummaryApi.getAllClients.url}?${query}`,
      );

      if (response.data.success) {
        setClients(response.data.data || []);
        const list = response.data.data || [];

        setClients(list);

        const categories = [
          ...new Set(list.flatMap((item) => item.clientCategories || [])),
        ];

        const states = [
          ...new Set(list.map((item) => item.clientId?.state).filter(Boolean)),
        ];

        const countries = [
          ...new Set(
            list.map((item) => item.clientId?.country).filter(Boolean),
          ),
        ];

        setFilterOptions((prev) => ({
          ...prev,
          categories,
          states,
          countries,
        }));
        setPagination((prev) => ({
          ...prev,
          total: response.data.total || 0,
          totalPages: response.data.totalPages || 1,
        }));
      }
    } catch (err) {
      console.log(err);

      toast.error(err.response?.data?.message || "Failed to fetch clients");
    } finally {
      setLoading(false);
    }
  }, [buildQuery]);

  useEffect(() => {
    fetchClients();
  }, [fetchClients]);

  const handleApplyFilters = () => {
    setAppliedFilters(filters);

    setPagination((prev) => ({
      ...prev,
      page: 1,
    }));

    setShowFilter(false);
  };

  const handleResetFilters = () => {
    setFilters(defaultFilters);

    setAppliedFilters(defaultFilters);

    setPagination((prev) => ({
      ...prev,
      page: 1,
    }));

    setShowFilter(false);
  };

  const handleSearch = (value) => {
    setFilters((prev) => ({
      ...prev,
      search: value,
    }));

    setAppliedFilters((prev) => ({
      ...prev,
      search: value,
    }));

    setPagination((prev) => ({
      ...prev,
      page: 1,
    }));
  };

  const handlePageChange = (page) => {
    setPagination((prev) => ({
      ...prev,
      page,
    }));
  };

  const handleItemsPerPageChange = (limit) => {
    setPagination((prev) => ({
      ...prev,
      page: 1,
      limit,
    }));
  };

  const activeFiltersCount = Object.values(appliedFilters).filter((value) => {
    if (Array.isArray(value)) return value.length > 0;
    return value !== "";
  }).length;

  const handleExportExcel = () => {
    toast.info("Excel Export");
  };

  const handleExportPDF = () => {
    toast.info("PDF Export");
  };
  return (
    <div className="p-4">
    {/* Header */}

<div className="bg-white rounded-xl p-5 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">

  <div>
    <h1 className="text-2xl font-bold text-gray-900">
      Client Listing
    </h1>

    <p className="text-sm text-gray-500 mt-1">
      Manage all onboarding clients
    </p>
  </div>

  <div className="flex flex-wrap items-center gap-3">

    <input
      type="text"
      placeholder="Search Client..."
      value={filters.search}
      onChange={(e) => handleSearch(e.target.value)}
      className="w-72 rounded-lg border border-gray-300 px-4 py-2 focus:border-red-500 focus:outline-none"
    />

    <button
      onClick={() => setShowFilter(true)}
      className="relative rounded-lg bg-red-100 p-3 hover:bg-red-200 transition"
    >
      <FaFilter />

      {activeFiltersCount > 0 && (
        <span className="absolute -right-2 -top-2 flex h-5 w-5 items-center justify-center rounded-full bg-red-600 text-xs text-white">
          {activeFiltersCount}
        </span>
      )}
    </button>

    <button
      onClick={handleExportExcel}
      className="rounded-lg bg-green-600 px-4 py-2 text-white hover:bg-green-700"
    >
      Excel
    </button>

    <button
      onClick={handleExportPDF}
      className="rounded-lg bg-red-600 px-4 py-2 text-white hover:bg-red-700"
    >
      PDF
    </button>

  </div>

</div>
      {loading ? (
        <PageLoader />
      ) : (
        <div className="">
          {/* Table */}

          <ClientListingTable
            data={clients}
            pagination={pagination}
            onPageChange={handlePageChange}
            onItemsPerPageChange={handleItemsPerPageChange}
            searchTerm={filters.search}
            setSearchTerm={handleSearch}
            onFilterClick={() => setShowFilter(true)}
            onExportExcel={handleExportExcel}
            onExportPDF={handleExportPDF}
            activeFiltersCount={activeFiltersCount}
          />

          {/* No Data */}

          {!loading && clients.length === 0 && <NoDataAvailable />}

          {/* Filter */}

          <ClientListingFilter
            isOpen={showFilter}
            onClose={() => setShowFilter(false)}
            filters={filters}
            setFilters={setFilters}
            onApply={handleApplyFilters}
            filterOptions={filterOptions}
            onReset={handleResetFilters}
          />
        </div>
      )}
    </div>
  );
}
